import React from 'react';
import { useMatch } from 'react-router-dom';

import styled from 'styled-components';

import { COMPANY_COMMUNITY_RELATION_TYPE } from 'constants/company';

import { GOOGLE_MAP_MARKER_SIZE } from './constants';

interface Props {
  type: number;
  color: string;
}

const Container = styled.div<{
  bgColor: string;
  zIndex: number;
}>`
  position: absolute;
  width: ${GOOGLE_MAP_MARKER_SIZE}px;
  height: ${GOOGLE_MAP_MARKER_SIZE}px;
  left: ${-GOOGLE_MAP_MARKER_SIZE / 2}px;
  top: ${-GOOGLE_MAP_MARKER_SIZE / 2}px;
  background-color: ${(props) => props.bgColor};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: solid 2px #fff;
  border-radius: 50%;
  cursor: pointer;
  z-index: ${(props) => props.zIndex};
`;

const MapMarkerIcon = (props: Props) => {
  const isOverviewPage = useMatch({ path: '/overview', end: true });

  const { type, color } = props;
  const isCommunity = type === COMPANY_COMMUNITY_RELATION_TYPE.COMMUNITY;
  const zIndex = isCommunity ? 999 : 1;
  const bgColor = isOverviewPage
    ? isCommunity
      ? 'var(--community-marker-blue)'
      : 'var(--community-marker-orange)'
    : isCommunity
      ? 'var(--text-primary)'
      : color;

  return <Container bgColor={bgColor} zIndex={zIndex} />;
};

export default MapMarkerIcon;
